import { render, staticRenderFns } from "./ShablonStatus.vue?vue&type=template&id=4f10e55f"
import script from "./ShablonStatus.vue?vue&type=script&lang=js"
export * from "./ShablonStatus.vue?vue&type=script&lang=js"
import style0 from "./ShablonStatus.vue?vue&type=style&index=0&id=4f10e55f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports